import { GET_DELIVERY_RATES, GET_DELIVERY_RATES_ERR, SET_DELIVERY_RATES } from './type';

export function getDeliveryRates() {
  return (dispatch, getState, { axios }) => {
    dispatch({
      type: GET_DELIVERY_RATES,
      payload: null
    });

    axios.get(`/v3/delivery-rates`)
      .then((response) => {
        // Sort by priority (lower number = higher priority)
        const sortedRates = response.data.sort((a, b) => a.priority - b.priority);

        dispatch({
          type: SET_DELIVERY_RATES,
          payload: sortedRates
        });
      })
      .catch((error) => {
        console.error('Error fetching delivery rates:', error);
        dispatch({
          type: GET_DELIVERY_RATES_ERR,
          payload: error.response?.data || 'Failed to fetch delivery rates'
        });
      });
  };
}

// Helper function to get the appropriate delivery rate based on cart total
export function getDeliveryRateForTotal(total, deliveryRates) {
  if (!deliveryRates || deliveryRates.length === 0) {
    return { rate: 55, min_spend: 0 }; // fallback to default
  }

  // Find the highest applicable rate (lowest min_spend that applies)
  let applicableRate = null;

  for (const rate of deliveryRates) {
    if (rate.active && total >= parseFloat(rate.min_spend)) {
      if (!applicableRate || parseFloat(rate.min_spend) > parseFloat(applicableRate.min_spend)) {
        applicableRate = rate;
      }
    }
  }

  // If no applicable rate found, use the base rate (min_spend = 0)
  if (!applicableRate) {
    applicableRate = deliveryRates.find(deliveryRate => deliveryRate.active && parseFloat(deliveryRate.min_spend) === 0) ||
      { rate: 55, min_spend: 0 }; // fallback
  }

  return {
    rate: parseFloat(applicableRate.rate),
    min_spend: parseFloat(applicableRate.min_spend)
  };
}

// Helper function to get the next threshold for free delivery
export function getNextFreeDeliveryThreshold(total, deliveryRates) {
  if (!deliveryRates || deliveryRates.length === 0) {
    return 499; // fallback to default
  }

  // Find the next free delivery threshold (rate = 0)
  const freeDeliveryRates = deliveryRates
    .filter(rate => rate.active && parseFloat(rate.rate) === 0 && parseFloat(rate.min_spend) > total)
    .sort((a, b) => parseFloat(a.min_spend) - parseFloat(b.min_spend));

  if (freeDeliveryRates.length > 0) {
    return parseFloat(freeDeliveryRates[0].min_spend);
  }

  return null; // No next threshold found
} 